module.exports = __webpack_public_path__ + "img/14_BC15_rate_your_rats.e9fca05e.jpg";